import script from "./BottomMenuBar.vue?vue&type=script&setup=true&lang=js"
export * from "./BottomMenuBar.vue?vue&type=script&setup=true&lang=js"

import "@/assets/css/components/bottom_menu_bar.css?vue&type=style&index=0&id=c3f42df6&scoped=true&lang=css"

import exportComponent from "C:\\DEVER\\withfounder.vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c3f42df6"]])

export default __exports__